import React, { Component } from 'react';
//import { connectHits } from 'react-instantsearch/dom';
import { Grid, } from 'semantic-ui-react'
import ChatBubble from './ChatBubble';



class WhatsappCustomHits extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    componentDidMount() {
        console.log("mini1 - ivan:"+this.props.ivan)
        //console.log("csxt1:mainCardObjects" + this.props.mainCardObjects.length);
    }

    getMessageKey = (hit) => {
        console.log("12x hit:"+JSON.stringify(hit,null,3))

        let key = hit.to;
        if(hit.to && hit.to.includes("702052564")){
            key = hit.from
        }else{
            key = hit.to
        }
    }
    
    render() {
        const hitsUI = 
        this.props.hits.map(hit =>
            <Grid.Column>
                <ChatBubble 
                key={hit.newFrom} 
                message={hit} 
                phone={hit.newTo}
                searchNow = {true}
                user={this.props.user}
                //isAdmin={this.state.isAdmin}
                algoliaUser = {this.props.algoliaUser}
                />
            </Grid.Column>
        )

        return <div style={{ marginTop: '10px' }}>
            <h1>{this.props.ivan}</h1>
            <Grid stackable columns={1}>
                {hitsUI}
            </Grid>


        </div>
    }
}

//const ConnectedCustomHit = connectHits(CustomHits);
//export default connectHits(CustomHits);
export default WhatsappCustomHits;

//export const chits = connectHits(CustomHits);


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappCustomHits.js